import { client } from '../operations';
import { store as storedStore } from '../../app/apollo-client-instance';

/**
 * combine the `currentMove` and `moveIqMove`,
 * two objects being used to store singleton client state within moveIq
 * async
 *
 * @param {ApolloClient} [store] the instance of the client
 */
export const getClientState = (store = storedStore()) =>
  store.query(client.currentMove()).then(({ data: { CurrentMove } }) =>
    store.query(client.moveIqMove(CurrentMove.id)).then(({ data }) => ({
      ...data,
      currentMove: CurrentMove,
    }))
  );

/**
 * combine the `currentMove` and `moveIqMove`,
 * two objects being used to store singleton client state within moveIq
 * sync
 *
 * @param {ApolloClient} [store] the instance of the client
 */

export const getClientStateSync = (store = storedStore()) => {
  const currentMove = store.cache.readQuery(client.currentMove()).CurrentMove;
  // TODO: Figure out why we cannot access the MoveIQ Move Syncronously...
  // TODO2: For some reason this fails miserably with the mocked e2e tests
  // but since we cannot use the value (since it never worked) just commenting it all out.
  // const { moveIqMove } = store.cache.readQuery(
  //   client.moveIqMove(currentMove.id)
  // );

  return {
    currentMove,
    // moveIqMove,
  };
};

export function getCurrentMove(store = storedStore()) {
  return store.cache.readQuery(client.currentMove()).CurrentMove;
}

export function setCurrentMove(store = storedStore(), newState) {
  const currentMove = getCurrentMove(store);
  store.cache.writeQuery({
    ...client.currentMove(),
    data: {
      CurrentMove: { ...currentMove, ...newState },
    },
  });
}
